import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "cart-item-removed-shelves"
};
const _hoisted_2 = {
  class: "removed-shelves-title"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "remove-shelves-list"
};
const _hoisted_5 = {
  alt: ""
};
const _hoisted_6 = ["src"];
import { ref, watch } from 'vue';
import { useLess } from '@/models/hooks';
import imageLink from '@/configs/imageLink';
import { imageCutEdgeAndSetSize } from '@/utils/common';
export default {
  __name: 'CartItemsRemovedFromShelves',
  props: ['removedData'],
  emits: ['updateCheck'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('views/cart/components/CartItemsRemovedFromShelves.less');
    const {
      SELECTED,
      NOT_SELECTED
    } = imageLink;
    const checkedAll = ref(false);
    const removedShelvesList = ref(props.removedData);
    watch(() => props.removedData, () => {
      removedShelvesList.value = props.removedData;
      if (removedShelvesList.value.every(item => item.check)) {
        checkedAll.value = true;
      } else {
        checkedAll.value = false;
      }
    }, {
      immediate: true
    });
    // selecte all
    const onSelectedAll = () => {
      removedShelvesList.value.forEach(item => {
        emit('updateCheck', {
          asin: item.asin,
          value: checkedAll.value
        });
      });
    };
    // Modify selected status
    const onCheckChange = item => {
      emit('updateCheck', {
        asin: item.asin,
        value: item.check
      });
    };
    return (_ctx, _cache) => {
      const _component_van_checkbox = _resolveComponent("van-checkbox");
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_checkbox, {
        class: "radio",
        modelValue: checkedAll.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => checkedAll.value = $event),
        "checked-color": "#eb1745",
        onClick: onSelectedAll
      }, {
        icon: _withCtx(checkboxProps => [_createElementVNode("img", {
          src: checkboxProps.checked ? _unref(SELECTED) : _unref(NOT_SELECTED)
        }, null, 8, _hoisted_3)]),
        _: 1
      }, 8, ["modelValue"]), _createTextVNode(" " + _toDisplayString(_ctx.$t('common.OFF_THE_SHELVES')), 1)]), _createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(removedShelvesList.value, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: item.asin,
          class: _normalizeClass({
            'm-r-20': index % 4 !== 3 ? true : false
          })
        }, [_withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [[_directive_lazy, _unref(imageCutEdgeAndSetSize)(item.mainImageUrl)]]), _createVNode(_component_van_checkbox, {
          class: "radio radio-item",
          modelValue: item.check,
          "onUpdate:modelValue": $event => item.check = $event,
          "checked-color": "#eb1745",
          onClick: $event => onCheckChange(item)
        }, {
          icon: _withCtx(checkboxProps => [_createElementVNode("img", {
            src: checkboxProps.checked ? _unref(SELECTED) : _unref(NOT_SELECTED)
          }, null, 8, _hoisted_6)]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onClick"])], 2);
      }), 128))])]);
    };
  }
};